var exports = {
  "Qs": "xa15a2ab7--0b6931--content",
  "ZZ": "xa15a2ab7--0b6931--field",
  "nf": "xa15a2ab7--0b6931--link",
};

module.exports = exports;
